import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: {
          // System
          "booking system": "Borneo Glamping reservations",
          "pages": "booking portal",

          // General Fields
          "name": "name",
          "phone no": "phone no",
          "email": "email",
          "date": "date",
          "time": "time",
          "payment proof": "transaction slip",

          // Modules
          "lot": "camp lot",
          "lots": "camp lots",
          "lot management": "camp lot management",
          "lot list": "camp lot list",
          "all lots": "all camp lots",

          "reservation": "reservation",
          "reservations": "reservations",

          "device": "device",
          "devices": "devices",

          "operating hour": "operating hour",
          "operating hours": "operating hours",

          "user": "user",
          "users": "users",

          "transaction": "transaction",
          "transactions": "transactions",

          "reports": "reports",

          // Table
          "table": "table",
          "data tables": "data tables",
          "no data": "no data available",

          // Actions (CRUD)
          "create": "create",
          "edit": "edit",
          "view": "view",
          "delete": "delete",

          "delete selected data": "delete selected data",
          "confirm delete": "are you sure you want to delete:",

          // Status / Device
          "status": "status",
          "vendor device id": "vendor device id",
          "on": "on",
          "off": "off",
          "log": "log",

          // Days
          "monday": "monday",
          "tuesday": "tuesday",
          "wednesday": "wednesday",
          "thursday": "thursday",
          "friday": "friday",
          "saturday": "saturday",
          "sunday": "sunday",

          // Payment
          "payment": "transaction",
          "payment status": "transaction status",
          "amount": "amount",
          "payment channel": "transaction channel",
          "ref no": "ref no",

          // Auth
          "username": "username",
          "password": "password",
          "role": "role",

          "login": "login",
          "logout": "logout",
          "sign in": "sign in",

          "username or email": "username or email",
          "enter your username/email & password to login": "enter your email & password to login",

          "successfully logged in!..": "successfully logged in!..",
          "invalid username/email or password": "invalid username/email or password",

          // ================= NEWLY ADDED KEYS =================

          // lot Form
          "new lot": "new camp lot",
          "lot name": "camp lot name",
          "enter lot name": "enter camp lot name",
          "description": "description",
          "enter description": "enter description",
          "address": "address",
          "enter address": "enter address",
          "contact phone": "contact phone",
          "enter contact phone": "enter contact phone",
          "active": "active",
          "inactive": "inactive",

          // Breadcrumbs
          "forms": "forms",
          "default forms": "default forms",
          "form layout": "form layout",

          // Misc UI
          "enter email": "enter email",
          "email privacy note": "we'll never share your email with anyone else.",
          "remember my preference": "remember my preference",
          "official receipt": "official receipt",
          "remarks": "remarks",
          "enter remarks": "enter remarks",
          "photo": "photo",
          "upload photo": "upload photo",
          "choose file": "choose file",
          "requires payment": "payment required",
          "requires approval": "approval required",
          "submit": "submit",
          "cancel": "cancel",
          "action": "action",
          "charged by": "charged by",
          "select type": "select type",
          "hourly": "per hour",
          "nightly": "per night",
          "daily": "per day",
          "monthly": "per month",
          "yearly": "per month",
          "flat fee": "flat rate",
          "default cost": "standard price",
          "remove": "remove",
          "add": "add",
          "day": "day",
          "select day": "select day",
          "start time": "start time",
          "end time": "end time",
          "edit lot": "edit lot",
          "change image": "change image",
          "existing image": "existing image",
          "pricing details": "pricing details",
          "view lot": "lot details",
          "user management": "user management",
          "user list": "user list",
          "confirm": "confirm",
          "confirm status": "are you sure you want to change the status",
          "new user": "new user",
          "new password": "new password",
          "reset password": "reset password",
          "enter new password": "enter new password",
          "all": "all",
          "turn all off": "turn all off",
          "turn all on": "turn all on",
          "light switch": "light switch",
          "last synced": "last synced",
          "never": "never",
          "devices list": "devices list",
          "devices management": "devices management",
          "confirm turn on": "are you sure you want to turn this on?",
          "confirm turn off": "are you sure you want to turn this off?",
          "confirm turn all on": "are you sure you want to turn all devices on?",
          "confirm turn all off": "are you sure you want to turn all devices off?",
          "device connection": "device connections",
          "back": "back",
          "dashboard": "overview",
          "activity logs": "activity logs",
          "new reservation": "new reservation",
          "special event": "special event",
          "maintenance": "maintenance",
          "booking": "booking",
          "select lot": "select lot",
          "purpose": "purpose",
          "phone number": "phone number",
          "special request": "special request",
          "pending": "pending",
          "approved": "approved",
          "confirmed": "confirmed",
          "cancelled": "cancelled",
          "paid": "paid",
          "not applicable": "not applicable",
          "booking ref": "ref",
          "date & time": "date & time",
          "reservation type": "type",
          "reservation management": "reservation management",
          "list view": "list",
          "schedule view": "schedule",
          "today": "today",
          "this week": "this week",
          "this month": "this month",
          "edit reservation": "edit reservation",
          "reservation details": "reservation details",
          "confirm payment": "confirm payment",
          "confirm reservation": "confirm reservation",
          "cancel reservation": "cancel reservation",
          "payment method": "transaction method",
          "payment methods": "transaction methods",
          "transaction details": "transaction details",
          "settings": "settings",
          "receipt": "receipt",
          "privacy policy": "privacy policy",
          "refund policy": "refund policy",
          "terms & conditions": "terms & conditions",
          "receipt number format": "receipt number format",
          "receipt title": "receipt title",
          "issuer name": "issuer name",
          "footer note": "footer note",
          "reset": "reset",
          "summarized terms": "summarized terms",
          "full terms": "full terms",
          "no logo": "no logo",
          "logo": "logo",
          "allow public booking": "public booking",
          "account": "account",
          "change password": "change password",
          "current password": "current password",
          "confirm new password": "confirm new password",
          "costs": "payments",
          "booking settings": "booking settings",
          "min lead time": "min lead time",
          "max lead time": "max lead time",
          "value": "value",
          "type": "type",
          "min lead time explanation": "minimum time required before booking. e.g. 1 day means users must book at least 1 day in advance",
          "max lead time explanation": "maximum advance booking allowed. e.g. 3 months means users can only book up to 3 months ahead",
          "range": "range",
          "month": "month",
          "year": "year",
          "next n month end": "next n month end",
          "next n year end": "next n year end",
          "lead_time": {
            "day": "{{value}} day",
            "days": "{{value}} days",
            "month": "{{value}} month",
            "months": "{{value}} months",
            "year": "{{value}} year",
            "years": "{{value}} years",
            "next_month_end": "Next {{value}} month end",
            "next_months_end": "Next {{value}} months end",
            "next_year_end": "Next {{value}} year end",
            "next_years_end": "Next {{value}} years end",
          },
          "download receipt": "download receipt",
          "sync device": "sync device",
          "general": "general",
          "site name": "site name",
          "monthly refresh day": "monthly refresh day",
          "payment details": "payment details",

          "this will be used only if lead time is not set for individual lots": "this will be used only if lead time is not set for individual lots",
          "if the selected day exceeds the number of days in a month, the system will use the last valid day of that month": "if the selected day exceeds the number of days in a month, the system will use the last valid day of that month",
          "seasons & holidays": "seasons & holidays",
          "peak cost": "peak season price",
          "peak season": "peak season",
          "holiday": "holiday",
          "click dates to mark peak": "click dates to mark peak season",
          "click dates to mark holiday": "click dates to mark holiday",
          "regular peak": "regular peak",
          "view page": "view page",
          "total reservations": "total online reservations",
          "total reservations today": "total reservations today",
          "pending reservations": "pending reservations",
          "view reservations": "view reservations",
          "today's reservations": "today's reservations",
          "view all": "view all",
          "manage": "manage",
          "delete logo": "delete logo",
          "bank transfer": "bank transfer",
          "bank_transfer": "bank transfer",
          "save": "save",
          "en": "english",
          "cn": "chinese",
          "bm": "malay",
          "view transaction slip": "view transaction slip",
          "transaction slip": "transaction slip",
          "transaction ID": "transaction ID",
          "created at": "created at",
          "transaction management": "transaction management",
          "monthly refresh date": "monthly refresh date (1-31)",
          "day of month (1-31)": "day of month (1-31)",
          "monthly refresh explanation": "bookings or quotas will reset on this day every month. Enter zero to disable feature.",
          "no upcoming schedules": "no upcoming schedules",
          "scheduled operations": "scheduled operations",
          "completed": "completed",
          "being payment of": "being payment of",
          "sort by": "sort by",
          "desc": "desc",
          "asc": "asc",
          "submitted at": "submitted at",
          "reservation date": "reservation date",
          "quick range": "quick range",
          "search name": "search name",
          "search booking ref": "search booking ref",
          "search purpose": "search purpose",
          "reset all": "reset all",
          "start date": "start date",
          "end date": "end date",
          "apply": "apply",
          "configurations": "settings",
          "insights": "insights",
          "operations": "operations",
          "send receipt email?": "send receipt email?",
          "do you want to email the receipt to the customer": "do you want to email the receipt to the customer?",
          "yes": "yes",
          "no": "no",
          "are you sure you want to update this transaction?": "are you sure you want to update this transaction?",
          "reservation slip": "reservation slip",
          "daily roster": "daily roster",
          "reservations list": "reservations list",
          "transactions list": "transactions list",
          "show filters": "show filters",
          "hide filters": "hide filters",
        }
      },

      // (unchanged other languages — no removals made)
      cn: {
        translations: {
          "lot booking system": "营地预约系统",
          "name": "姓名",
          "phone no": "电话号码",
          "email": "电子邮件",
          "date": "日期",
          "time": "时间",
          "payment proof": "汇款收据",

          "lot": "营地",
          "lots": "营地",
          "lot management": "营地管理",
          "lot list": "营地列表",
          "all lots": "所有营地",

          "reservation": "预约",
          "reservations": "预约",

          "device": "设备",
          "devices": "设备",

          "operating hour": "开放时间",
          "operating hours": "开放时间",

          "user": "用户",
          "users": "用户",

          "transaction": "账目",
          "transactions": "账目",

          "reports": "报告",

          "table": "表格",
          "data tables": "数据表",
          "no data": "没有数据",

          "create": "创建",
          "edit": "编辑",
          "view": "查看",
          "delete": "删除",

          "delete selected data": "删除所选数据",
          "confirm delete": "您确定要删除：",

          "status": "状态",
          "vendor device id": "设备编号",
          "on": "开启",
          "off": "关闭",
          "log": "日志",

          "monday": "星期一",
          "tuesday": "星期二",
          "wednesday": "星期三",
          "thursday": "星期四",
          "friday": "星期五",
          "saturday": "星期六",
          "sunday": "星期日",

          "payment": "汇款",
          "payment status": "汇款状态",
          "amount": "金额",
          "payment channel": "汇款方式",
          "ref no": "参考编号",

          "username": "用户名",
          "password": "密码",
          "role": "角色",

          "login": "登录",
          "logout": "登出",
          "sign in": "登录",

          "username or email": "用户名或电子邮件",
          "enter your username/email & password to login": "输入您的用户名/电子邮件和密码进行登录",

          "successfully logged in!..": "登录成功！",
          "invalid username/email or password": "用户名/邮箱或密码错误",

          "new lot": "新营地",
          "lot name": "营地名称",
          "enter lot name": "输入营地名称",
          "description": "描述",
          "enter description": "输入描述",
          "address": "地址",
          "enter address": "输入地址",
          "contact phone": "联系电话",
          "enter contact phone": "输入联系电话",
          "active": "启用",
          "inactive": "停用",
          "forms": "表单",
          "default forms": "默认表单",
          "form layout": "表单布局",
          "enter email": "输入电子邮件",
          "email privacy note": "我们不会与任何人共享您的电子邮件。",
          "remember my preference": "记住我的偏好",
          "remarks": "备注",
          "enter remarks": "输入备注",
          "photo": "照片",
          "upload photo": "上传照片",
          "choose file": "选择文件",
          "requires payment": "须收费",
          "requires approval": "须审核",
          "submit": "提交",
          "cancel": "取消",
          "action": "操作",
          "charged by": "收费方式",
          "select type": "选择类型",
          "hourly": "每小时",
          "nightly": "每夜",
          "daily": "每日",
          "monthly": "每月",
          "yearly": "每年",
          "flat fee": "一次性收费",
          "default cost": "默认费用",
          "peak cost": "高峰期费用",
          "remove": "删除",
          "add": "添加",
          "day": "天",
          "select day": "选择日期",
          "start time": "开始时间",
          "end time": "结束时间",
          "edit lot": "编辑营地",
          "change image": "更换图片",
          "existing image": "当前图片",
          "pricing details": "价格详情",
          "view lot": "营地详情",
          "user management": "用户管理",
          "user list": "用户列表",
          "confirm": "确认",
          "confirm status": "你确定要更改状态吗",
          "new user": "新用户",
          "new password": "新密码",
          "reset password": "重置密码",
          "enter new password": "输入新密码",
          "all": "全部",
          "turn all off": "全部关闭",
          "turn all on": "全部开启",
          "light switch": "灯开关",
          "last synced": "最后同步",
          "never": "从未",
          "devices list": "设备列表",
          "devices management": "设备管理",
          "confirm turn on": "确定要开启此设备吗？",
          "confirm turn off": "确定要关闭此设备吗？",
          "confirm turn all on": "确定要开启所有设备吗？",
          "confirm turn all off": "确定要关闭所有设备吗？",
          "device connection": "设备连接",
          "back": "返回",
          "dashboard": "概览",
          "activity logs": "活动日志",
          "new reservation": "新预约",
          "special event": "特别活动",
          "maintenance": "维护",
          "booking": "预约",
          "select lot": "选择营地",
          "purpose": "用途",
          "phone number": "电话号码",
          "special request": "特殊要求",
          "pending": "待处理",
          "approved": "已批准",
          "confirmed": "已确认",
          "cancelled": "已取消",
          "paid": "已汇款",
          "not applicable": "不适用",
          "booking ref": "编号",
          "date & time": "日期与时间",
          "reservation type": "类型",
          "reservation management": "预约管理",
          "list view": "列表",
          "schedule view": "日程",
          "today": "今天",
          "this week": "本周",
          "this month": "本月",
          "edit reservation": "编辑预约",
          "reservation details": "预约详情",
          "confirm payment": "确认汇款",
          "confirm reservation": "确认预约",
          "cancel reservation": "取消预约",
          "payment method": "汇款方式",
          "payment methods": "汇款方式",
          "transaction details": "汇款详情",
          "settings": "设置",
          "receipt": "收据",
          "privacy policy": "隐私政策",
          "refund policy": "退款政策",
          "terms & conditions": "条款与条件",
          "receipt number format": "收据编号格式",
          "receipt title": "收据标题",
          "issuer name": "发行方名称",
          "footer note": "页脚备注",
          "reset": "重置",
          "summarized terms": "条款摘要",
          "full terms": "完整条款",
          "no logo": "没有标志",
          "logo": "标志",
          "allow public booking": "公开预约",
          "account": "账号",
          "change password": "更改密码",
          "current password": "当前密码",
          "confirm new password": "确认新密码",
          "costs": "费用",
          "booking settings": "预约设置",
          "min lead time": "最短提前时间",
          "max lead time": "最长提前时间",
          "value": "数值",
          "type": "类型",
          "min lead time explanation": "预约所需的最短提前时间。例如：1天表示用户必须至少提前1天预约",
          "max lead time explanation": "允许的最长提前预约时间。例如：3个月表示用户最多只能提前3个月预约",
          "range": "范围",
          "month": "月",
          "year": "年",
          "next n month end": "下 n 个月月底",
          "next n year end": "下 n 年年底",
          "lead_time": {
            "day": "{{value}}天",
            "days": "{{value}}天",
            "month": "{{value}}个月",
            "months": "{{value}}个月",
            "year": "{{value}}年",
            "years": "{{value}}年",
            "next_month_end": "接下来{{value}}个月月底",
            "next_months_end": "接下来{{value}}个月月底",
            "next_year_end": "接下来{{value}}年年底",
            "next_years_end": "接下来{{value}}年年底",
          },
          "download receipt": "下载收据",
          "sync device": "同步设备",
          "general": "通用",
          "site name": "网站名称",
          "monthly refresh day": "每月刷新日期",
          "payment details": "汇款详情",
          "completed": "完成",
          "this will be used only if lead time is not set for individual lots": "仅在营地未单独设置提前时间时生效",
          "if the selected day exceeds the number of days in a month, the system will use the last valid day of that month": "如果所选日期超过当月天数，系统将使用该月最后一个有效日期",
          "seasons & holidays": "旺季与假期",
          "peak season": "旺季",
          "holiday": "假期",
          "click dates to mark peak": "点击日期以标记为旺季",
          "click dates to mark holiday": "点击日期以标记为假期",
          "regular peak": "固定旺季时段",
          "view page": "查看页面",
          "total reservations today": "今日预约总数",
          "total reservations": "线上预约总数",
          "pending reservations": "待处理预约",
          "view reservations": "查看预约",
          "today's reservations": "今日预约",
          "view all": "查看全部",
          "manage": "管理",
          "delete logo": "删除标志",
          "bank transfer": "银行汇款",
          "bank_transfer": "银行汇款",
          "save": "保存",
          "en": "英文",
          "cn": "中文",
          "bm": "马来文",
          "view transaction slip": "查看汇款凭单",
          "transaction slip": "汇款凭单",
          "transaction ID": "汇款编号",
          "created at": "创建于",
          "transaction management": "账目管理",
          "monthly refresh date": "每月刷新日期 (1-31)",
          "day of month (1-31)": "每月日期（1-31）",
          "monthly refresh explanation": "系统将在每月的这一天重置预订或配额。输入 0 关闭功能。",
          "no upcoming schedules": "没有来临的操作定时",
          "scheduled operations": "定时操作",
          "being payment of": "收费事项",
          "official receipt": "正式收据",
          "sort by": "排序方式",
          "desc": "降序",
          "asc": "升序",
          "submitted at": "提交时间",
          "reservation date": "预约日期",
          "quick range": "快选范围",
          "search name": "搜索名称",
          "search booking ref": "搜索预约编号",
          "search purpose": "搜索用途",
          "reset all": "重置全部",
          "start date": "开始日期",
          "end date": "结束日期",
          "apply": "搜索",
          "configurations": "设置",
          "insights": "洞察",
          "operations": "运营",
          "send receipt email?": "发送收据邮件？",
          "do you want to email the receipt to the customer": "您要将收据通过电子邮件发送给客户吗？",
          "yes": "是",
          "no": "否",
          "are you sure you want to update this transaction?": "您确定要更新此交易吗？",
          "daily roster": "每日行程",
          "reservation slips": "预约单据",
          "reservations list": "预约列表",
          "transactions list": "汇款列表"
        }
      },

      bm: {
        translations: {
          "lot booking system": "sistem tempahan lot",
          "name": "nama",
          "phone no": "no telefon",
          "email": "emel",
          "date": "tarikh",
          "time": "masa",
          "payment proof": "resit transaksi",

          "lot": "lot",
          "lots": "lot perkhemahan",
          "lot management": "pengurusan lot perkhemahan",
          "lot list": "senarai lot perkhemahan",
          "all lots": "semua lot perkhemahan",

          "reservation": "tempahan",
          "reservations": "tempahan",

          "device": "peranti",
          "devices": "peranti",

          "operating hour": "waktu operasi",
          "operating hours": "waktu operasi",

          "user": "pengguna",
          "users": "pengguna",

          "transaction": "transaksi",
          "transactions": "transaksi",

          "reports": "laporan",

          "table": "jadual",
          "data tables": "jadual data",
          "no data": "tiada data",

          "create": "cipta",
          "edit": "sunting",
          "view": "lihat",
          "delete": "padam",

          "delete selected data": "padam data dipilih",
          "confirm delete": "adakah anda pasti mahu padam:",

          "status": "status",
          "vendor device id": "id peranti vendor",
          "on": "hidup",
          "off": "tutup",
          "log": "log",

          "monday": "isnin",
          "tuesday": "selasa",
          "wednesday": "rabu",
          "thursday": "khamis",
          "friday": "jumaat",
          "saturday": "sabtu",
          "sunday": "ahad",

          "payment": "pembayaran",
          "payment status": "status pembayaran",
          "amount": "jumlah",
          "payment channel": "saluran pembayaran",
          "ref no": "no rujukan",

          "username": "nama pengguna",
          "password": "kata laluan",
          "role": "peranan",

          "login": "log masuk",
          "logout": "log keluar",
          "sign in": "log masuk",

          "username or email": "nama pengguna atau emel",
          "enter your username/email & password to login": "masukkan nama pengguna/emel & kata laluan untuk log masuk",

          "successfully logged in!..": "berjaya log masuk!",
          "invalid username/email or password": "nama pengguna/emel atau kata laluan tidak sah",

          // Added
          "new lot": "lot perkhemahan baru",
          "lot name": "nama lot perkhemahan",
          "enter lot name": "masukkan nama lot perkhemahan",
          "description": "penerangan",
          "enter description": "masukkan penerangan",
          "address": "alamat",
          "enter address": "masukkan alamat",
          "contact phone": "telefon",
          "enter contact phone": "masukkan telefon",
          "active": "aktif",
          "inactive": "tidak aktif",
          "forms": "borang",
          "default forms": "borang lalai",
          "form layout": "susun atur borang",
          "enter email": "masukkan emel",
          "email privacy note": "kami tidak akan berkongsi emel anda.",
          "remember my preference": "ingati pilihan saya",
          "remarks": "catatan",
          "enter remarks": "masukkan catatan",
          "photo": "gambar",
          "upload photo": "muat naik gambar",
          "choose file": "pilih fail",
          "requires payment": "perlu pembayaran",
          "requires approval": "perlu kelulusan",
          "submit": "hantar",
          "cancel": "batal",
          "action": "tindakan",
          "charged by": "jenis caj",
          "select type": "pilih jenis",
          "hourly": "setiap jam",
          "daily": "setiap hari",
          "monthly": "setiap bulan",
          "yearly": "setiap tahun",
          "flat fee": "caj tetap",
          "default cost": "caj biasa",
          "peak cost": "caj puncak",
          "remove": "padam",
          "add": "tambah",
          "day": "hari",
          "select day": "pilih hari",
          "start time": "masa mula",
          "end time": "masa tamat",
          "edit lot": "sunting lot",
          "change image": "tukar gambar",
          "existing image": "gambar sekarang",
          "pricing details": "butiran harga",
          "view lot": "butiran lot",
          "user management": "pengurusan pengguna",
          "user list": "senarai pengguna",
          "confirm": "sahkan",
          "confirm status": "adakah anda pasti mahu menukar status",
          "new user": "pengguna baru",
          "new password": "kata laluan baharu",
          "reset password": "set semula kata laluan",
          "enter new password": "masukkan kata laluan baharu",
          "all": "semua",
          "turn all off": "tutup semua",
          "turn all on": "hidupkan semua",
          "light switch": "suis lampu",
          "last synced": "terakhir disegerakkan",
          "never": "tidak pernah",
          "devices list": "senarai peranti",
          "devices management": "pengurusan peranti",
          "confirm turn on": "adakah anda pasti mahu hidupkan peranti ini?",
          "confirm turn off": "adakah anda pasti mahu matikan peranti ini?",
          "confirm turn all on": "adakah anda pasti mahu hidupkan semua peranti?",
          "confirm turn all off": "adakah anda pasti mahu matikan semua peranti?",
          "device connection": "sambungan peranti",
          "back": "kembali",
          "dashboard": "ringkasan",
          "activity logs": "log aktiviti",
          "new reservation": "tempahan baru",
          "special event": "acara khas",
          "maintenance": "penyelenggaraan",
          "booking": "tempahan",
          "select lot": "pilih lot",
          "purpose": "tujuan",
          "phone number": "nombor telefon",
          "special request": "permintaan khas",
          "pending": "menunggu",
          "approved": "diluluskan",
          "confirmed": "disahkan",
          "cancelled": "dibatalkan",
          "paid": "telah dibayar",
          "not applicable": "tidak berkenaan",
          "booking ref": "rujukan",
          "date & time": "tarikh & masa",
          "reservation type": "jenis",
          "reservation management": "pengurusan tempahan",
          "list view": "senarai",
          "schedule view": "jadual",
          "today": "hari ini",
          "this week": "minggu ini",
          "this month": "bulan ini",
          "edit reservation": "sunting tempahan",
          "reservation details": "butiran tempahan",
          "confirm payment": "sahkan pembayaran",
          "confirm reservation": "sahkan tempahan",
          "cancel reservation": "batalkan tempahan",
          "payment method": "kaedah transaksi",
          "payment methods": "kaedah transaksi",
          "transaction details": "butiran transaksi",
          "settings": "tetapan",
          "receipt": "resit",
          "privacy policy": "dasar privasi",
          "refund policy": "dasar bayaran balik",
          "terms & conditions": "terma & syarat",
          "receipt number format": "format nombor resit",
          "receipt title": "tajuk resit",
          "issuer name": "nama pengeluar",
          "footer note": "nota kaki",
          "reset": "set semula",
          "summarized terms": "ringkasan terma",
          "full terms": "terma penuh",
          "no logo": "tiada logo",
          "logo": "logo",
          "allow public booking": "tempahan awam",
          "account": "akaun",
          "change password": "tukar kata laluan",
          "current password": "kata laluan semasa",
          "confirm new password": "sahkan kata laluan baru",
          "costs": "pembayaran",
          "booking settings": "tetapan tempahan",
          "min lead time": "tempoh minimum sebelum tempahan",
          "max lead time": "tempoh maksimum sebelum tempahan",
          "value": "nilai",
          "type": "jenis",
          "min lead time explanation": "tempoh minimum sebelum tempahan. contoh: 1 hari bermaksud pengguna mesti menempah sekurang-kurangnya 1 hari lebih awal",
          "max lead time explanation": "tempoh maksimum tempahan awal yang dibenarkan. contoh: 3 bulan bermaksud pengguna hanya boleh menempah sehingga 3 bulan ke hadapan",
          "range": "julat",
          "month": "bulan",
          "year": "tahun",
          "next n month end": "akhir n bulan depan",
          "next n year end": "akhir n tahun depan",
          "lead_time": {
            "day": "{{value}} hari",
            "days": "{{value}} hari",
            "month": "{{value}} bulan",
            "months": "{{value}} bulan",
            "year": "{{value}} tahun",
            "years": "{{value}} tahun",
            "next_month_end": "1 bulan akan datang (akhir bulan)",
            "next_months_end": "{{value}} bulan akan datang (akhir bulan)",
            "next_year_end": "1 tahun akan datang (akhir tahun)",
            "next_years_end": "{{value}} tahun akan datang (akhir tahun)",
          },
          "download receipt": "muat turun resit",
          "sync device": "segerakkan peranti",
          "general": "umum",
          "site name": "nama tapak",
          "monthly refresh day": "hari reset bulanan",
          "payment details": "butiran transaksi",

          "this will be used only if lead time is not set for individual lots": "hanya digunakan jika masa tempahan tidak ditetapkan pada setiap lot",
          "if the selected day exceeds the number of days in a month, the system will use the last valid day of that month": "jika hari yang dipilih melebihi jumlah hari dalam bulan tersebut, sistem akan menggunakan hari terakhir yang sah",
          "seasons & holidays": "musim puncak & cuti",
          "peak season": "musim puncak",
          "holiday": "cuti",
          "click dates to mark peak": "klik tarikh untuk tandakan sebagai musim puncak",
          "click dates to mark holiday": "klik tarikh untuk tandakan sebagai cuti",
          "regular peak": "waktu puncak tetap",
          "view page": "lihat halaman",
          "total reservations today": "jumlah tempahan hari ini",
          "total reservations": "jumlah tempahan atas talian",
          "pending reservations": "tempahan belum diproses",
          "view reservations": "lihat tempahan",
          "today's reservations": "tempahan hari ini",
          "view all": "lihat semua",
          "manage": "urus",
          "delete logo": "padam logo",
          "bank transfer": "pindahan bank",
          "bank_transfer": "pindahan bank",
          "save":"simpan",
          "en": "inggeris",
          "cn": "cina",
          "bm": "melayu",
          "view transaction slip": "lihat resit transaksi",
          "transaction slip": "resit transaksi",
          "transaction ID": "ID transaksi",
          "created at": "dicipta pada",
          "transaction management": "pengurusan transaksi",
          "monthly refresh date": "tarikh tetapan semula bulanan (1-31)",
          "day of month (1-31)": "hari dalam bulan (1-31)",
          "monthly refresh explanation": "tempahan atau kuota akan ditetapkan semula pada hari ini setiap bulan. Masukkan kosong untuk nyahaktifkan.",
          "no upcoming schedules": "tiada jadual akan datang",
          "scheduled operations": "operasi berjadual",
          "completed": "siap",
          "being payment of": "perkara persembahan",
          "official receipt": "resit rasmi",
          "sort by": "susun mengikut",
          "desc": "menurun",
          "asc": "menaik",
          "submitted at": "dihantar pada",
          "reservation date": "tarikh tempahan",
          "quick range": "julat pantas",
          "search name": "cari nama",
          "search booking ref": "cari rujukan tempahan",
          "search purpose": "cari tujuan",
          "reset all": "set semula semua",
          "start date": "tarikh mula",
          "end date": "tarikh tamat",
          "apply": "cari",
          "configurations": "tetapan",
          "insights": "cerapan",
          "operations": "operasi",
          "send receipt email?": "hantar e-mel resit?",
          "do you want to email the receipt to the customer": "adakah anda mahu menghantar resit melalui e-mel kepada pelanggan?",
          "yes": "ya",
          "no": "tidak",
          "are you sure you want to update this transaction?": "adakah anda pasti mahu mengemas kini transaksi ini?",
          "daily roster": "jadual harian",
          "reservation slip": "slip tempahan",
          "reservations list": "senarai tempahan",
          "transactions list": "senarai transaksi"
        }
      }
    },

    fallbackLng: "en",
    debug: false,

    ns: ["translations"],
    defaultNS: "translations",

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;